import { api } from "./configs/axiosConfigs";

export const VisitorsAPI = {
  getVisitors: async () => {
    const response = await api.get(`/visitors?page=1&items_per_page=2000`);

    return response?.data;
  },

  getVisitor: async (id) => {
    const response = await api.get(`/visitors/${id}`);

    return response?.data;
  },

  addVisitor: async (form) => {
    const response = await api.post(`/visitors`, form);

    return response?.data;
  },

  updateVisitor: async (form, id) => {
    const response = await api.patch(`/visitors/${id}`, form);

    return response?.data;
  },

  deleteVisitor: async (id) => {
    const response = await api.delete(`/visitors/${id}`);

    return response?.data;
  },
};
